import { useState, useEffect } from 'react'
import { Loading, Button, Dialog, Toast } from 'react-vant'
import { useNavigate } from 'react-router-dom'
import teacherAffairsApi from '../../../api/teacherAffairs'

const LEAVE_TYPE = {
  sick: { label: '病假', color: '#e11d48' },
  personal: { label: '事假', color: '#fa8c16' },
  maternity: { label: '产假', color: '#7c3aed' },
  marriage: { label: '婚假', color: '#ec4899' },
  bereavement: { label: '丧假', color: '#64748b' },
  other: { label: '其他', color: '#64748b' },
}

export default function AdminPendingLeave() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [list, setList] = useState([])

  const load = async () => {
    setLoading(true)
    try {
      const res = await teacherAffairsApi.getPendingLeaves({ page: 1, page_size: 100 })
      const items = res?.data?.items || res?.items || (Array.isArray(res) ? res : [])
      setList(Array.isArray(items) ? items : [])
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '加载失败')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  const doApprove = async (item) => {
    try {
      const res = await teacherAffairsApi.approveLeave(item.id, { action: 'approve' })
      const d = res?.data || res || {}
      if (d.impact_status === 'detected') {
        Toast.success(`已通过，识别到 ${d.impact_lesson_count || 0} 节受影响课时`)
      } else if (d.impact_status === 'no_impact') {
        Toast.success('已通过，本次请假不涉及课时')
      } else {
        Toast.success('已通过')
      }
      load()
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '操作失败')
    }
  }

  const doReject = (item) => {
    Dialog.confirm({
      title: '驳回请假',
      message: `确认驳回 ${item.teacher_name} 的请假？`,
      showCancelButton: true,
    }).then(async () => {
      try {
        await teacherAffairsApi.approveLeave(item.id, { action: 'reject', comment: '' })
        Toast.success('已驳回')
        load()
      } catch (e) {
        Toast.fail(e.response?.data?.detail || '操作失败')
      }
    }).catch(() => {})
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      {/* 注意：react-vant 的 NavBar 默认 leftArrow 是 <ArrowLeft/> 元素，
          若传布尔 true 会在内部 cloneElement(true) 时崩溃 —— 所以这里不传 leftArrow */}
      <NavBarSimple title="待审批请假" onBack={() => navigate(-1)} />

      <div style={{ padding: '12px 16px 24px' }}>
        <div style={{
          fontSize: 12, color: '#475569', marginBottom: 12, lineHeight: 1.6,
          background: '#eff6ff', padding: '8px 10px', borderRadius: 8,
        }}>
          全校待审批的请假。通过后系统会<b>自动识别</b>受影响的课时并进入「代课安排 · 待安排」。
        </div>

        {loading ? (
          <div style={{ padding: '40px 0', textAlign: 'center' }}>
            <Loading type="spinner" color="#056b4f">加载中…</Loading>
          </div>
        ) : list.length === 0 ? (
          <div style={{ padding: '60px 0', textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>
            没有待审批的请假
          </div>
        ) : (
          list.map(item => {
            const lt = LEAVE_TYPE[item.leave_type] || LEAVE_TYPE.other
            return (
              <div key={item.id} style={{
                background: '#fff', borderRadius: 12, padding: 14, marginBottom: 12,
                borderLeft: '3px solid #056b4f',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <span style={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>
                    {item.teacher_name}
                  </span>
                  <span style={{
                    fontSize: 11, color: lt.color, border: `1px solid ${lt.color}`,
                    borderRadius: 4, padding: '0 5px',
                  }}>{lt.label}</span>
                  <span style={{ fontSize: 13, color: '#0891b2', marginLeft: 'auto' }}>
                    {item.duration_days} 天
                  </span>
                </div>
                <div style={{ fontSize: 13, color: '#475569', marginBottom: 4 }}>
                  {item.start_date} ~ {item.end_date}
                </div>
                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 10, lineHeight: 1.5 }}>
                  {item.reason}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button size="small" type="primary" style={{ flex: 1 }}
                    onClick={() => doApprove(item)}>通过</Button>
                  <Button size="small" plain style={{ flex: 1 }}
                    onClick={() => doReject(item)}>驳回</Button>
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

/** 自绘顶部栏：避免 NavBar 的 leftArrow 布尔传参坑，也避免额外依赖 */
function NavBarSimple({ title, onBack }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px',
      background: '#fff', borderBottom: '1px solid #f1f5f9',
    }}>
      <button onClick={onBack} aria-label="返回" style={{
        background: 'none', border: 'none', padding: 0, cursor: 'pointer',
        display: 'flex', alignItems: 'center', color: '#0f172a', fontSize: 20, lineHeight: 1,
      }}>‹</button>
      <span style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{title}</span>
    </div>
  )
}
